import React from "react";

// Approved customer testimonials, rendered directly beneath the hero action row on the solutions
// pages via CalloutSection. Each page uses the quote from its own segment. Kept here so quote and
// attribution stay together — these are customer-approved copy, so edit the words only with fresh
// sign-off.
export const intakeBreathingQuote: React.ReactNode = (
  <>
    For the first time, all of our channels — Shopify, Amazon, TikTok, subscriptions — live in{" "}
    <em>one place we can actually trust.</em> The best part is being able to explore it ourselves.
    It works so well. The DataFabrIQ team replaced the reports we used to assemble by hand with
    live dashboards, and the turnaround has been remarkably quick. It genuinely feels like an
    extension of our team.
  </>
);

export const intakeBreathingCite = "— Marjolijn Zwart · Head of FP&A, Intake Breathing";

export const taiSoftwareQuote: React.ReactNode = (
  <>
    We were considering buying a commissions tool, and we would have still been stuck maintaining
    the spreadsheet next to it. Our plan has retro-tiering, cohort rate preservation, and a bonus
    gate for overperformance. This detail takes time to maintain and eats hours every month.
    DataFabrIQ <em>built our plan, not a generic version of it,</em> and it ties my signed comp
    statements to the dollar, while still letting my reps and I open any number and see where every
    dollar came from. We were live for the May run. And the same work gave us our pipeline review
    and our ARR rollforward, which I wasn't expecting to get out of a commissions project.
  </>
);

export const taiSoftwareCite = "— Kevin Trosian · CFO, Tai Software";
